// src/App.tsx
import React from "react";
import Home from "./pages/Home";

const App: React.FC = () => {
  return <Home />;
};

export default App;
